import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { DocumentTemplatesService, ProjectsService } from '@cosmos/angular/api';
import { ErrorService } from '@cosmos/angular/utils';
import { DocumentTemplate, Project } from '@cosmos/shared';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';

@Component({
    selector: 'cosmos-project-reports-settings',
    imports: [TranslatePipe, ReactiveFormsModule,
        DividerModule, CheckboxModule, ButtonModule, InputTextModule, IftaLabelModule, SelectModule],
    templateUrl: 'project-reports-settings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ProjectReportsSettingsComponent implements OnInit {

    @Input()
    project: Project = null;

    @Output()
    updatedProject = new EventEmitter<Project>();

    reportsConfig;
    readonly templateOptions = signal<{ label: string; value: string | null }[]>([{ label: '(None)', value: null }]);

    constructor(
        private projectsService: ProjectsService,
        private dtService: DocumentTemplatesService,
        private formBuilder: FormBuilder,
        private errorService: ErrorService,
    ) { }

    ngOnInit() {
        const rc = this.project.reportConfig;
        this.reportsConfig = this.formBuilder.group({
            reportsEnabled: new FormControl(this.project.reportsEnabled),
            reportsEmail: new FormControl(this.project.reportsEmail),
            templateMaturityMeasurement:    new FormControl(rc?.templateMaturityMeasurement ?? null),
            templateTemperatureMeasurement: new FormControl(rc?.templateTemperatureMeasurement ?? null),
            templateQualityControlReport:   new FormControl(rc?.templateQualityControlReport ?? null),
        });

        this.dtService.find().subscribe({
            next: (response) => {
                const templates: DocumentTemplate[] = response.body ?? [];
                this.templateOptions.set([
                    { label: '(None)', value: null },
                    ...templates.map(t => ({ label: t.name ?? t._id, value: t._id })),
                ]);
            },
            error: (e) => this.errorService.handleError(e),
        });
    }

    updateProject(formValue: any) {
        const { reportsEnabled, reportsEmail, templateMaturityMeasurement, templateTemperatureMeasurement, templateQualityControlReport } = formValue;

        this.projectsService.update([this.project._id, { reportsEnabled, reportsEmail }]).subscribe({
            next: (response) => this.updatedProject.emit(response.body),
            error: (e) => this.errorService.handleError(e),
        });

        this.projectsService.updateReportConfig(this.project._id, {
            templateMaturityMeasurement:    templateMaturityMeasurement ?? undefined,
            templateTemperatureMeasurement: templateTemperatureMeasurement ?? undefined,
            templateQualityControlReport:   templateQualityControlReport ?? undefined,
        }).subscribe({
            error: (e) => this.errorService.handleError(e),
        });
    }
}